import { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router";
import styles from "./BuySell.module.scss";
import { isEmpty } from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { getCoinDetail } from "../../../actions/getCoinDetail";
import {
  hiddenLoadingPage,
  showLoadingPage,
} from "../../../actions/loadingPage";
import ErrorMessageHook from "../../../helpers/errors_notifications/ErrorMessage";
import Num2persian from "num2persian";
import { num2English, showPrice } from "../../../utils/priceFunc";
import { userCoinBalance } from "../../../actions/user";
import { coinUsersBalance } from "../../../services/userServices";
import { usersMakeOrders } from "../../../services/adminServices";
import { errorMessage, successMessage } from "../../../utils/messages";
import LayoutCoin from "./LayoutCoin";
//Icons
import copyIcon from "../../../styles/icon/CopyIcon2.svg";
import VerticalIcon from "../../../styles/icon/menu/Vertical_switch.svg";
export default function SellCoin() {
  const history = useHistory();
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [switchButton, setSwitchButton] = useState(false);
  const [coinValue, setCoinValue] = useState("");
  const [priceValue, setPriceValue] = useState("");
  const [messageBox, setMessageBox] = useState("");
  const [coinUserBalance, setCoinUserBalance] = useState({});
  const { name } = useParams();
  //State's
  const COIN_DATA = useSelector((state) => state.coinInfo.data);
  const userId = useSelector((state) => state.userId);
  const userRial = useSelector((state) => state.fullUserInfo.coinBalance);
  //End State's
  ///// CALCULATOR
  const changeRialPrice = (e) => {
    const calc = num2English(e.target.value)?.replace(/\D/g, "");
    setPriceValue(calc);
    setCoinValue(showPrice(calc / COIN_DATA?.arzfi_buy_price));
  };
  const changeCoinPrice = (e) => {
    const calc = num2English(e.target.value)?.match(/\d|\./g)?.join("") || "";
    setCoinValue(calc);
    const rialValue = calc * +COIN_DATA?.arzfi_buy_price;
    setPriceValue(rialValue.toString()?.split(".")[0]);
  };
  ///// End Calculator
  const dispatch = useDispatch();
  useEffect(() => {
    let mounted = true;
    const getThisCoinInfo = async () => {
      try {
        await dispatch(getCoinDetail(name));
        dispatch(hiddenLoadingPage());
      } catch (ex) {
        dispatch(showLoadingPage());
      }
    };
    //
    (async () => {
      dispatch(showLoadingPage());
      if (mounted) {
        await getThisCoinInfo();
        dispatch(userCoinBalance("irt"));
        getUserThisCoinBalance();
      }
    })();
    //
    const reloadInfo = setInterval(() => {
      getThisCoinInfo();
    }, 30000);
    return () => {
      clearInterval(reloadInfo);
      mounted = false;
    };
  }, []);
  const getUserThisCoinBalance = async () => {
    const { data } = await coinUsersBalance(name);
    setCoinUserBalance(data);
  };
  const choiceAllCoins = () => {
    let amount =
      coinUserBalance.asset.balance - coinUserBalance.asset.locked || 0;
    setCoinValue(amount);
    const rialValue = amount * +COIN_DATA?.arzfi_buy_price;
    setPriceValue(rialValue?.toString()?.split(".")[0]);
  };
  const handleBuyCoin = async (e) => {
    e.preventDefault();
    if (!+coinValue)
      return setMessageBox("تعداد یا مبلغ فروش به درستی وارد نشده است.");
    if (+coinValue < +COIN_DATA.minSellAmount)
      return setMessageBox(
        `حداقل مقدار فروش ${COIN_DATA.faName} ${COIN_DATA.minSellAmount}`
      );
    if (+coinValue > +COIN_DATA.maxSellAmount)
      return setMessageBox(
        `حداکثر مقدار فروش ${COIN_DATA.faName} ${COIN_DATA.maxSellAmount}`
      );
    if (
      Number(coinUserBalance.asset.balance - coinUserBalance.asset.locked) <
      +coinValue
    )
      return setMessageBox("موجودی حساب شما کافی نمیباشد");

    const body = {
      asset: name,
      confirmed: false,
      orderAmount: coinValue,
      orderType: "sell",
    };
    try {
      setDisabledBtn(true);
      const { data } = await usersMakeOrders(body);
      if (data.error) {
        errorMessage(data.error);
      } else {
        successMessage(data.message);
        setPriceValue(0);
        setCoinValue(0);
        dispatch(userCoinBalance("irt"));
        getUserThisCoinBalance();
      }
    } catch (ex) {
      errorMessage("دوباره تلاش کنید");
    } finally {
      setDisabledBtn(false);
    }
  };
  return (
    <LayoutCoin>
      {messageBox && (
        <ErrorMessageHook
          setMessageBox={setMessageBox}
          messageBox={messageBox}
        />
      )}
      <div>
        <form onSubmit={handleBuyCoin}>
          {switchButton ? (
            <>
              <div className={styles.second_input}>
                <input
                  className="changeBackgroundToWhite"
                  onChange={changeRialPrice}
                  value={isNaN(priceValue) ? "" : priceValue}
                  inputMode="decimal"
                />
                <div
                  className={` changeFontColorToBlack ${styles.second_input_placeholder}`}
                >
                  مبلغ کل(تومان)
                </div>
              </div>
              {priceValue && (
                <div
                  className={`font_color_white ${styles.show_persian_price}`}
                >
                  {Num2persian(priceValue)} تومان
                </div>
              )}
              <div className={styles.user_wallet_amount}>
                <div className={`font_color_white ${styles.title_count}`}>
                  موجودی کیف پول شما:
                </div>
                <div className={`font_color_white ${styles.user_coins}`}>
                  <div className={styles.symbol_coin}>تومان</div>
                  <div className={styles.coin_amount}>
                    {userRial?.asset &&
                      showPrice(
                        +userRial.asset.balance - +userRial.asset.locked
                      )}
                  </div>
                </div>
              </div>
              <div className={styles.switch_container}>
                <div
                  className={styles.button_change_to_sell}
                  onClick={() => setSwitchButton(!switchButton)}
                >
                  <img src={VerticalIcon} alt="" width={20} height={20} />
                </div>
              </div>
              <div className={styles.first_input}>
                <input
                  className="changeBackgroundToWhite"
                  disabled
                  readOnly
                  value={isNaN(priceValue) ? "" : showPrice(coinValue)}
                />
                <div
                  className={`changeFontColorToBlack ${styles.first_input_placeholder}`}
                >
                  مقدار({COIN_DATA.faName})
                </div>
              </div>
              <div
                className={styles.user_coin_count}
                onClick={() => choiceAllCoins()}
              >
                <div className={`font_color_white ${styles.title_count}`}>
                  موجودی کیف پول شما:
                </div>
                <div className={`font_color_white ${styles.user_coins}`}>
                  <div className={styles.symbol_coin}>
                    <img
                      src={copyIcon}
                      alt="bbb"
                      width={14}
                      height={14}
                      className="convertPicToGreen"
                    />{" "}
                    {COIN_DATA?.symbol}
                  </div>
                  <div className={styles.coin_amount}>
                    {coinUserBalance?.asset &&
                      +coinUserBalance.asset.balance -
                        +coinUserBalance.asset.locked}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className={styles.first_input}>
                <input
                  className="changeBackgroundToWhite"
                  onChange={changeCoinPrice}
                  value={coinValue}
                  inputMode="decimal"
                />
                <div
                  className={`changeFontColorToBlack ${styles.first_input_placeholder}`}
                >
                  مقدار({COIN_DATA?.faName})
                </div>
              </div>
              <div className={styles.user_coin_count}>
                <div className={`font_color_white ${styles.title_count}`}>
                  موجودی کیف پول شما:
                </div>
                <div
                  className={`font_color_white ${styles.user_coins}`}
                  onClick={() => choiceAllCoins()}
                >
                  <div className={styles.symbol_coin}>
                    <img
                      src={copyIcon}
                      alt="bbb"
                      width={14}
                      height={14}
                      className="convertPicToGreen"
                    />{" "}
                    {COIN_DATA?.symbol}
                  </div>
                  <div className={styles.coin_amount}>
                    {coinUserBalance?.asset &&
                      +coinUserBalance.asset.balance -
                        +coinUserBalance.asset.locked}
                  </div>
                </div>
              </div>
              <div className={styles.switch_container}>
                <div
                  className={styles.button_change_to_sell}
                  onClick={() => setSwitchButton(!switchButton)}
                >
                  <img src={VerticalIcon} alt="" width={20} height={20} />
                </div>
              </div>
              <div className={styles.second_input}>
                <input
                  className="changeBackgroundToWhite"
                  disabled
                  readOnly
                  value={priceValue === "NaN" ? "" : showPrice(priceValue)}
                />
                <div
                  className={`changeFontColorToBlack ${styles.second_input_placeholder}`}
                >
                  مبلغ کل(تومان)
                </div>
              </div>
              {priceValue && (
                <div
                  className={`font_color_white ${styles.show_persian_price}`}
                >
                  {Num2persian(priceValue)} تومان
                </div>
              )}
              <div className={styles.user_wallet_amount}>
                <div className={`font_color_white ${styles.title_count}`}>
                  موجودی کیف پول شما:
                </div>
                <div className={`font_color_white ${styles.user_coins}`}>
                  <div className={styles.symbol_coin}>تومان</div>
                  <div className={styles.coin_amount}>
                    {userRial?.asset &&
                      showPrice(
                        +userRial.asset.balance - +userRial.asset.locked
                      )}
                  </div>
                </div>
              </div>
            </>
          )}
          <div className={styles.button_place}>
            <button
              className={styles.button_red}
              type="submit"
              disabled={isEmpty(userId) ? true : disabledBtn}
            >
              فروش <span>{COIN_DATA?.faName}</span>
            </button>
          </div>
        </form>
        {isEmpty(userId) ? (
          <div className={styles.message_for_login}>
            ابتدا وارد{" "}
            <span onClick={() => history.push("/authorization/login")}>
              حساب کاربری
            </span>{" "}
            خود شوید
          </div>
        ) : (
          ""
        )}
      </div>
    </LayoutCoin>
  );
}
